module.exports = __webpack_public_path__ + "static/card-twitter.b1b1c2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/card-twitter.png
// module id = 440
// module chunks = 114276838955818